/**
 * @param {Array} workers
 * @param {boolean} rowsDisabled
 * @param {function} onTerminate
 */
import React from "react";
import TableRow from "./TableRow";
import styles from "./QueueWorkersPage.module.scss";

const QueueWorkersTable = ({ workers, rowsDisabled, onTerminate }) => {
  const rows = workers.map((worker) => (
    <TableRow
      key={worker.id}
      worker={worker}
      disabled={rowsDisabled}
      onTerminate={onTerminate}
    />
  ));

  return (
    <div className={styles.tableWrap}>
      <table className={styles.table}>
        <colgroup>
          <col className={styles.colId} />
          <col className={styles.colPid} />
          <col className={styles.colJobType} />
          <col className={styles.colDate} />
          <col className={styles.colDate} />
          <col className={styles.colStatus} />
          <col className={styles.colActions} />
        </colgroup>
        <thead>
          <tr>
            <th scope="col">Id</th>
            <th scope="col">PID</th>
            <th scope="col">Job type</th>
            <th scope="col">Started</th>
            <th scope="col">Modified</th>
            <th scope="col">Status</th>
            <th scope="col" aria-hidden="true" />
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </div>
  );
};

export default QueueWorkersTable;
